import { BigWinComponent } from "ags/components/big-win-component";
import { BigWinFirework } from "ags/components/big-win-firework";
import { BigWinThresholds } from "ags/utils/win-magnitude";
import { Components } from "appworks/components/components";
import { Services } from "appworks/services/services";
import { SoundService } from "appworks/services/sound/sound-service";
import { Contract } from "appworks/utils/contracts/contract";
import { Timer } from "appworks/utils/timer";

class BigWinCommand {
    protected bigWinLevel: BigWinThresholds;
    protected timerId: number;
    protected stopped: boolean = false;

    public start(bigWinLevel: BigWinThresholds): void {
        this.bigWinLevel = bigWinLevel;
        this.stopped = false;

        const bigWinComponent = Components.get(BigWinComponent);
        bigWinComponent.start(bigWinLevel);

        if (bigWinLevel >= BigWinThresholds.BIG) {
            this.playCoinSounds();
        }
    }

    public stop(immediateStop = false): Contract<void> {
        this.stopped = true;

        if (this.bigWinLevel >= BigWinThresholds.BIG) {
            this.stopCoinSounds(immediateStop);
        }

        if (this.timerId) {
            Timer.clearInterval(this.timerId);
            Services.get(SoundService).customEvent("big_win_fireworks_end");
        }

        return Components.get(BigWinComponent).stop(immediateStop);
    }

    protected launchFireworks(): number {
        Services.get(SoundService).customEvent("big_win_fireworks_start");
        return Timer.setInterval(() => new BigWinFirework(), 500);
    }

    protected stopCoinSounds(immediateStop = false): void {
        Services.get(SoundService).customEventContract("end_coins").then(() => {
            if (!immediateStop) {
                Services.get(SoundService).customEvent("coins_end");
            }
        });
    }

    protected playCoinSounds() {
        Services.get(SoundService).customEventContract("coins_start").then(() => {
            if (!this.stopped) {
                Services.get(SoundService).customEvent("coins_loop");
            }
        });
    }
}

export const bigWinCommand = new BigWinCommand();
